import {useSyncExternalStore} from "react";

const subscribe = (onChange: () => void) => {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
};

const getSnapshot = () => navigator.onLine;

const useIsOnline = () => useSyncExternalStore(subscribe, getSnapshot);

export default useIsOnline;
